module.exports = __webpack_public_path__ + "static/media/lease_management_icon.b6a8a881.png";